import React, { useEffect, useState } from 'react';
import { Flex, Button, Text, Box } from 'rebass';
import { IoIosArrowRoundBack } from 'react-icons/io';
import Progress from './Progress';
// import { useFormikContext } from 'formik';
import { FaArrowRight } from 'react-icons/fa';

function Footer({
    onNextPress,
    onBack,
    type = '',
    nextButtonText,
    disabled = false,
    sx = {},
    middleButton = undefined,
    onSkipPress,
    onBackDisabled = false,
    // percentComplete,
    borderRadius = "23px",
    // maxWidth = 500,
    noOfTransitions,
    mt = 5,
    backText = '',
    isDisabled,
    buttonSx = {}
}) {
    const [animationStyle, setAnimationStyle] = useState({
        transform: 'translate(0%, 0%)',
        transition: 'opacity 1s ease',
        opacity: 0,
    });

    const animateElement = () => {
        setAnimationStyle((prevStyle) => ({
            ...prevStyle,
            opacity: 0,
        }));

        setTimeout(() => {
            setAnimationStyle((prevStyle) => ({
                ...prevStyle,
                opacity: 1,
            }));
        }, 1000);
    };

    useEffect(() => {
        animateElement()
    }, [noOfTransitions])

    return (<Box
        // maxWidth={maxWidth}
        sx={{
            // position: ['fixed'],
            // bottom: 0,
            // left: maxWidth === '100vw' && 0,
            pb: [5, 5, 8, 2],
            width: '100%',
            // width: 600,
            background: ['white', middleButton ? 'white' : "unset"],
            zIndex: 3,
            m: 'auto',
            mt,
            ...animationStyle
        }}
    >
        {/* <Progress percentComplete={percentComplete} /> */}
        <Flex
            justifyContent="center"
            alignItems="center"
            sx={{
                pt: [2, 2],
                ...sx,
            }}
        >
            <Flex
                height={40}
                justifyContent="space-around"
                alignItems="center"
                bg="#fff"
                sx={{ borderRadius: 'medium', cursor: onBackDisabled || !onBack ? 'not-allowed' : 'pointer' }}
                onClick={onBackDisabled || !onBack ? undefined : onBack}
                disabled={onBackDisabled}
            >
                {onBack && (
                    <Text as={IoIosArrowRoundBack} color="mineShaft" minWidth={"24px"} fontSize={24} />
                )}
                <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={2} fontWeight={400} fontSize="15px">
                    {' '}
                    {backText}
                </Text>
            </Flex>
            {middleButton}
            <Flex width="100%">
                {onSkipPress && (
                    <Text
                        mr={3}
                        mt={2}
                        onClick={onSkipPress}
                        color="#000"
                        fontSize="18px"
                        fontWeight={700}
                        lineHeight="120%"
                        sx={{
                            cursor: 'pointer',
                            fontStyle: 'italic',
                        }}
                    >
                        Skip
                    </Text>
                )}
                <Button
                    height={40}
                    py={1}
                    px={5}
                    bg={disabled ? "grey" : "brand"}
                    type={type}
                    onClick={onNextPress}
                    disabled={disabled && !isDisabled}
                    sx={{ borderRadius, opacity: isDisabled ? 0.5 : 1, display: 'flex', justifyContent: 'center', alignItems: 'center', ml: 'auto', ...buttonSx }}
                >
                    {nextButtonText}
                    {nextButtonText === 'Nope, that’s all!' && <Box ml={2} as={FaArrowRight} color="#fff" />}
                </Button>
            </Flex>
        </Flex>
    </Box>
    );
}

export default Footer;
